let mlcgSwiperInit = false;
let mlcgSwiper = null;
let mlpsSwiperInit = false;
let mlpsSwiper = null;

function destroySwiperInstance(instance) {
  if (!instance) return;

  if (Array.isArray(instance)) {
	instance.forEach(function (swiper) {
	  if (swiper && typeof swiper.destroy === 'function') {
		swiper.destroy();
	  }
	});
  } else if (typeof instance.destroy === 'function') {
	instance.destroy();
  }
}

function handleMlpsRightArrowClick() {
  if (mlpsSwiper && typeof mlpsSwiper.slideNext === 'function') {
	mlpsSwiper.slideNext();
  }
}

function mlcgSwiperToggle() {
  const noMLCGSwiper = window.matchMedia('(max-width: 767px)');
  const yesMLCGSwiper = window.matchMedia('(min-width: 768px)');

  if (yesMLCGSwiper.matches) {
	if (!mlcgSwiperInit) {
	  mlcgSwiperInit = true;

	  mlcgSwiper = new Swiper('.mlcg-grid.swiper-container', {
		slidesPerView: 3.5,
		spaceBetween: 18,
		freeMode: true,
		mousewheel: {
		  releaseOnEdges: true,
		  forceToAxis: true
		},
		allowTouchMove: true
	  });
	}

	if (mlpsSwiperInit) {
	  mlpsSwiperInit = false;
	  destroySwiperInstance(mlpsSwiper);
	  mlpsSwiper = null;

	  document.body.removeEventListener('click', handleBodyClickForMlpsArrow);
	}
  } else if (noMLCGSwiper.matches) {
	if (mlcgSwiperInit) {
	  mlcgSwiperInit = false;
	  destroySwiperInstance(mlcgSwiper);
	  mlcgSwiper = null;
	}

	if (!mlpsSwiperInit) {
	  mlpsSwiperInit = true;

	  mlpsSwiper = new Swiper('.media-library-popular-series .swiper-container', {
		slidesPerView: 1.3,
		spaceBetween: 8,
		freeMode: true,
		mousewheel: {
		  releaseOnEdges: true,
		  forceToAxis: true
		},
		allowTouchMove: true
	  });

	  document.body.addEventListener('click', handleBodyClickForMlpsArrow);
	}
  }
}

function handleBodyClickForMlpsArrow(event) {
  const arrow = event.target.closest('.mlps-right-arrow');

  if (arrow) {
	handleMlpsRightArrowClick();
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const mlhSwiper = new Swiper('.media-library-hero .swiper-container', {
	slidesPerView: 1,
	pagination: {
	  el: '.swiper-pagination',
	  type: 'bullets',
	  clickable: true
	}
  });

  window.addEventListener('load', mlcgSwiperToggle);
  window.addEventListener('resize', mlcgSwiperToggle);
});